import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    checkPermission,
    getDefaultOptionByValue, getEmployeeBreakOptions, getEmployeeCategoryOptions,
    getEmployeeTypeOptions, getKathestosOptions,
    getResignationCauseOptions,
    getSexOptions, getWorkingDaysPerWeekOptions, isEmpty
} from "../../../../_helpers/commonFunctions";
import {setSaveEditEmployee} from "../../../../_reducers/activitySlice";
import {setEditEmployee, setEditBankInfo, resetEditBankInfo} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {Col, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import DateBox from "../../../primer/DateBox";
import AccountingBox from "../../../primer/AccountingBox";
import TextArea from "../../../common/TextArea";
import BetterCheckBox from "../../../common/BetterCheckBox";
import ShowQRModal from "./show-qr-modal";
import LogTable from "../../../primer/LogTable";
import useErganiInstallationOptions from "../../../../hooks/useErganiInstallationOptions";
import {extendedBankOptions} from "../../../../_data/dummy_banks";
import EditableTable from "../../../primer/Editable-Table";
import {useTranslation} from "../../../../hooks/useTranslation";

const EditEmployee = () => {
    const {t, locale} = useTranslation();
    const dispatch = useDispatch();
    const saveEditEmployee = useSelector((state) => state.ACTIVITY.saveEditEmployee);
    const editEmployee = useSelector((state) => state.ACCOUNTING_DATA.editEmployee);
    const editBankInfo = useSelector((state) => state.ACCOUNTING_DATA.editBankInfo);
    const companyHasErgani = useSelector((state) => state.PAYROLL.companyHasErgani);
    const currentDate = new Date();
    const companyInstallations = useErganiInstallationOptions(false);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const [bankInfoIncrKey, setBankInfoIncrKey] = useState(0);

    const employeeBankInfoColumns = [
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankFriendlyName'),
            field: "bankFriendlyName",
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.bankInfoTable.bankInstitute'),
            field: "bankInstitute",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                options: extendedBankOptions,
            }
        },
        {
            name: "IBAN",
            field: "iban",
            editable: true,
            width: "50%",
            inputType: {
                type: 'text',
            }
        },
    ]

    useEffect(() => {
        setBankInfoIncrKey(bankInfoIncrKey + 1);
    }, [editEmployee?.bankInfo])

    useEffect(() => {
        setBankInfoTableColumns(employeeBankInfoColumns.slice());
    }, [locale])

    const [bankInfoTableColumns, setBankInfoTableColumns] = useState(employeeBankInfoColumns.slice());

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveEditEmployee) dispatch(setSaveEditEmployee(true));

        let name;
        let value;
        if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'ac') {
            value = e.target.value;
            name = ddname;
        } else if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else if (type === "bcb") {
            if (ddname === "isActive") {
                value = e.target.checked ? "active" : "inactive";
            } else {
                value = e.target.checked;
            }
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        const employeeData = Object.assign({}, editEmployee);

        employeeData[name] = value;
        if (name === "resignationDate") {
            if (value) {
                employeeData.isActive = "inactive";
            } else {
                employeeData.isActive = "active";
            }
        }
        dispatch(setEditEmployee(employeeData));
    }

    const bankInfoTableActions = {
        insert: (e, data) => {
            // Set if editing the form
            if (!saveEditEmployee) {
                dispatch(setSaveEditEmployee(true));
            }

            let tempBankInfo = Object.assign({}, editBankInfo);

            if (e.key !== "Enter") {
                tempBankInfo[data.field] = data.value;
                dispatch(setEditBankInfo(tempBankInfo));
                if (data.value !== "") {
                    let updatedBankInfo = Object.assign({}, tempBankInfo);
                    let oldBankInfo = editEmployee?.bankInfo || [];

                    dispatch(setEditEmployee({
                        ...editEmployee,
                        bankInfo: [...oldBankInfo, updatedBankInfo]
                    }));
                    dispatch(resetEditBankInfo());
                }
            } else {
                let updatedBankInfo = Object.assign({}, tempBankInfo);
                let oldBankInfo = editEmployee?.bankInfo || [];

                if (e.key === "Enter" || data.value === "add") {
                    if (updatedBankInfo && updatedBankInfo.bankFriendlyName !== '' && updatedBankInfo.bankInstitute !== '' && updatedBankInfo.iban !== '') {
                        dispatch(setEditEmployee({
                            ...editEmployee,
                            bankInfo: [...oldBankInfo, updatedBankInfo]
                        }));
                        dispatch(resetEditBankInfo());
                        dispatch(setSaveEditEmployee(true));
                    }
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveEditEmployee) {
                dispatch(setSaveEditEmployee(true));
            }

            let bankInfo = editEmployee.bankInfo.slice();
            bankInfo[rowIndex] = {...bankInfo[rowIndex], ...data};
            dispatch(setEditEmployee({...editEmployee, bankInfo: bankInfo})); // update data
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveEditEmployee) {
                dispatch(setSaveEditEmployee(true));
            }

            let bankInfo = editEmployee.bankInfo.slice();
            bankInfo.splice(rowIndex, 1);
            dispatch(setEditEmployee({...editEmployee, bankInfo: bankInfo}));
        }
    }

    const disabledFields = editEmployee.isFromHyper === "true" || editEmployee.fromErgani === true;

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col md={12} className="d-flex align-items-center justify-content-end">
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2">{t('PosNew.active')}</label>
                        <BetterCheckBox
                            className="mb-2"
                            name="isActive"
                            checked={editEmployee.isActive === "active"}
                            onChange={(e) => handleOnChange(e, "bcb", "isActive")}
                        />
                    </div>
                </Col>
            </Row>
            <p className="text-muted mb-1">
                <i>{t('EmployeeNew.personalLabel')}</i>
            </p>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.firstName.name')}
                        name="firstName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.firstName.placeholder')}
                        value={editEmployee.firstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.firstName === '' &&
                        <div className="text-danger">{t('EmployeeNew.firstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.lastName.name')}
                        name="lastName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.lastName.placeholder')}
                        value={editEmployee.lastName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.lastName === '' &&
                        <div className="text-danger">{t('EmployeeNew.lastName.required')}</div>}
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={t('EmployeeNew.sex.name')}
                        name="sex"
                        disabled={disabledFields}
                        placeholder="Επιλέξτε Φύλο"
                        options={getSexOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "sex")}
                        value={getDefaultOptionByValue(getSexOptions(), editEmployee.sex, 'value', 'label', 'value')}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.sex === '' &&
                        <div className="text-danger">{t('EmployeeNew.sex.required')}</div>}
                </Col>
                <Col md={2}>
                    <DateBox
                        label={t('EmployeeNew.birthDate.name')}
                        name="birthDate"
                        allowOtherYears={true}
                        required={true}
                        disabled={disabledFields}
                        minDate={new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        maxDate={new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate())}
                        selected={editEmployee?.birthDate ? new Date(editEmployee.birthDate) : ""}
                        onChange={(e) => handleOnChange(e, 'dp', 'birthDate')}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.birthDate === '' &&
                        <div className="text-danger">{t('EmployeeNew.birthDate.required')}</div>}
                </Col>
                <Col md={2}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.vatNumber.name')}
                        name="vatNumber"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.vatNumber.placeholder')}
                        value={editEmployee.vatNumber}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.vatNumber === '' &&
                        <div className="text-danger">{t('EmployeeNew.vatNumber.required')}</div>}
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.fatherFirstName.name')}
                        name="fatherFirstName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.fatherFirstName.placeholder')}
                        value={editEmployee.fatherFirstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.fatherFirstName === '' &&
                        <div className="text-danger">{t('EmployeeNew.fatherFirstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.fatherLastName.name')}
                        name="fatherLastName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.fatherLastName.placeholder')}
                        value={editEmployee.fatherLastName}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.motherFirstName.name')}
                        name="motherFirstName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.motherFirstName.placeholder')}
                        value={editEmployee.motherFirstName}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.motherFirstName === '' &&
                        <div className="text-danger">{t('EmployeeNew.motherFirstName.required')}</div>}
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.motherLastName.name')}
                        name="motherLastName"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.motherLastName.placeholder')}
                        value={editEmployee.motherLastName}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label="Τηλέφωνο"
                        name="phone"
                        placeholder="Εισάγετε Τηλέφωνο"
                        value={editEmployee.phone}
                        required={false}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        className="w-100"
                        label="E-Mail"
                        name="email"
                        placeholder="Εισάγετε E-Mail"
                        value={editEmployee.email}
                        required={false}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <hr/>
            <p className="text-muted">
                <i>{t('EmployeeNew.securityLabel')}</i>
            </p>
            <Row className={"mb-3"}>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.amka.name')}
                        name="amka"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.amka.placeholder')}
                        value={editEmployee.amka}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.amka === '' &&
                        <div className="text-danger">{t('EmployeeNew.amka.required')}</div>}
                </Col>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.amika.name')}
                        name="amika"
                        placeholder={t('EmployeeNew.amika.placeholder')}
                        value={editEmployee.amika}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={"ΑΜΑ"}
                        name="ama"
                        placeholder={"Εισάγετε ΑΜΑ"}
                        value={editEmployee.ama}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <hr/>
            <p className="text-muted">
                <i>{t('EmployeeNew.workingLabel')}</i>
            </p>
            <Row className={"mb-3"}>
                <Col md={3}>
                    <Dropdown
                        label={t('EmployeeNew.employeeCategory.name')}
                        name="employeeCategory"
                        placeholder={t('EmployeeNew.employeeCategory.placeholder')}
                        options={getEmployeeCategoryOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "employeeCategory")}
                        value={getDefaultOptionByValue(getEmployeeCategoryOptions(), editEmployee.employeeCategory, 'value', 'label', 'value')}
                    />
                    {saveEditEmployee && !disabledFields && !editEmployee.employeeCategory &&
                        <div className="text-danger">{t('EmployeeNew.employeeCategory.required')}</div>}
                </Col>
                <Col md={3}>
                    <Dropdown
                        label={t('EmployeeNew.employeeType.name')}
                        name="employeeType"
                        placeholder={t('EmployeeNew.employeeType.placeholder')}
                        options={getEmployeeTypeOptions()}
                        enabledValue={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "dd", "employeeType")}
                        value={getDefaultOptionByValue(getEmployeeTypeOptions(), editEmployee.employeeType, 'value', 'label', 'value')}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.employeeType === '' &&
                        <div className="text-danger">{t('EmployeeNew.employeeType.required')}</div>}
                </Col>
                <Col md={6}>
                    <Input
                        className="w-100"
                        label={t('EmployeeNew.specialty.name')}
                        name="specialty"
                        disabled={disabledFields}
                        placeholder={t('EmployeeNew.specialty.placeholder')}
                        value={editEmployee.specialty}
                        required={true}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.specialty === '' &&
                        <div className="text-danger">{t('EmployeeNew.specialty.required')}</div>}
                </Col>
                <Col md={4}>
                    <Dropdown
                        label={t('EmployeeNew.installation.name')}
                        options={companyInstallations}
                        value={getDefaultOptionByValue(companyInstallations, editEmployee.installation, 'value', 'label', 'value')}
                        enabledValue={true}
                        searchEnable={true}
                        required={true}
                        name="installation"
                        onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.installation === '' &&
                        <div className="text-danger">{t('EmployeeNew.installation.required')}</div>}
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Εβδομαδιαίες ημέρες εργασίας"}
                        name={"workingDaysPerWeek"}
                        key={Math.random()}
                        disabled={disabledFields}
                        options={getWorkingDaysPerWeekOptions()}
                        defaultValue={getDefaultOptionByValue(getWorkingDaysPerWeekOptions(), editEmployee.workingDaysPerWeek, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'workingDaysPerWeek')}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"workingHoursPerWeek"}
                        label={"Εβδομαδιαίες ώρες εργασίας"}
                        type={"number"}
                        disabled={disabledFields}
                        value={editEmployee.workingHoursPerWeek}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"symbatikesWorkingHoursPerWeek"}
                        label={"Συμβ. εβδ. ώρες εργασίας"}
                        type={"number"}
                        value={editEmployee.symbatikesWorkingHoursPerWeek}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"workingExperienceYears"}
                        label={"Χρόνια προϋπηρεσίας"}
                        type={"number"}
                        disabled={disabledFields}
                        value={editEmployee.workingExperienceYears}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={2}>
                    <Input
                        name={"firstYearPermits"}
                        label={"Άδειες πρώτου έτους"}
                        type={"number"}
                        disabled={disabledFields}
                        value={editEmployee.firstYearPermits}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Input
                        name={"breakMinutes"}
                        label={"Χρόνος διαλείμματος (σε λεπτά)"}
                        type={"number"}
                        disabled={disabledFields}
                        value={editEmployee.breakMinutes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Διάλειμμα εντός/εκτός ωραρίου"}
                        name={"breakMinutesWhen"}
                        key={Math.random()}
                        disabled={disabledFields}
                        options={getEmployeeBreakOptions()}
                        defaultValue={getDefaultOptionByValue(getEmployeeBreakOptions(), editEmployee.breakMinutesWhen, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'breakMinutesWhen')}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={"Καθεστώς Απασχόλησης"}
                        name={"kathestos"}
                        key={Math.random()}
                        disabled={disabledFields}
                        options={getKathestosOptions()}
                        defaultValue={getDefaultOptionByValue(getKathestosOptions(), editEmployee.kathestos, 'value', 'label', 'value')}
                        onChange={(e) => handleOnChange(e, 'dd', 'kathestos')}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        classes="w-100 mb-3"
                        label={t('EmployeeNew.employmentDate.name')}
                        name="employmentDate"
                        allowOtherYears={true}
                        disabled={disabledFields}
                        required={true}
                        minDate={new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        selected={editEmployee?.employmentDate ? new Date(editEmployee.employmentDate) : ""}
                        onChange={(e) => handleOnChange(e, 'dp', 'employmentDate')}
                    />
                    {saveEditEmployee && editEmployee.isFromHyper !== "true" && editEmployee.employmentDate === '' &&
                        <div className="text-danger">{t('EmployeeNew.employmentDate.required')}</div>}
                </Col>
                <Col md={2}>
                    <label className="" htmlFor="prefered-price">{t('EmployeeNew.salary.name')}</label>
                    <AccountingBox
                        name="salary"
                        className="mb-3 form-control"
                        placeholder={t('ProductsNewGeneralEdit.preferredPrice.placeholder')}
                        defaultValue={editEmployee.salary}
                        onChange={(e) => handleOnChange(e, 'ac', 'salary')}
                    />
                </Col>
            </Row>
            {companyHasErgani && (
                <Row>
                    <Col md={2}>
                        <BetterCheckBox
                            name={"erganiCard"}
                            text={"Κάρτα εργασίας"}
                            className={"mt-4"}
                            checked={editEmployee.erganiCard}
                            onChange={(e) => handleOnChange(e, "bcb", "erganiCard")}
                        />
                    </Col>
                    {editEmployee.erganiCard === true && (
                        <React.Fragment>
                            <Col md={3}>
                                <Input
                                    name={"flexibleAttendanceMinutes"}
                                    label={"Ευέλικτος Χρόνος Προσέλευσης (σε λεπτά)"}
                                    type={"number"}
                                    required={true}
                                    value={editEmployee.flexibleAttendanceMinutes}
                                    onChange={(e) => handleOnChange(e)}
                                />
                                {saveEditEmployee && isEmpty(editEmployee.flexibleAttendanceMinutes) && <div className="text-danger">Απαιτείται ο χρόνος προσέλευσης</div>}
                            </Col>
                            {checkPermission("custom-sales", permissionsData) && (
                                <Col md={3}>
                                    <BetterCheckBox
                                        name={"autoSendErganiCard"}
                                        text={"Αυτόματη αποστολή κάρτας εργασίας"}
                                        className={"mt-4"}
                                        checked={editEmployee.autoSendErganiCard}
                                        onChange={(e) => handleOnChange(e, "bcb", "autoSendErganiCard")}
                                    />
                                </Col>
                            )}
                            <Col md={3}>
                                <ShowQRModal employeeData={editEmployee} />
                            </Col>
                        </React.Fragment>
                    )}
                </Row>
            )}
            <Row className={"mt-3"}>
                <Col md={2}>
                    <DateBox
                        classes="w-100 mb-3"
                        label={t('EmployeeNew.resignationDate')}
                        name="resignationDate"
                        allowOtherYears={true}
                        minDate={editEmployee.employmentDate ? editEmployee.employmentDate : new Date(currentDate.getFullYear() - 100, currentDate.getMonth(), currentDate.getDate())}
                        maxDate={new Date()}
                        disabled={disabledFields}
                        selected={editEmployee?.resignationDate ? new Date(editEmployee.resignationDate) : ""}
                        onChange={(e) => handleOnChange(e, 'dp', 'resignationDate')}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        label={t('EmployeeNew.resignationCause')}
                        options={getResignationCauseOptions()}
                        value={getDefaultOptionByValue(getResignationCauseOptions(), editEmployee.resignationCause, 'value', 'label', 'value')}
                        enabledValue={true}
                        disabled={disabledFields}
                        searchEnable={true}
                        name="resignationCause"
                        onChange={(e) => handleOnChange(e, 'dd', 'resignationCause')}
                    />
                </Col>
            </Row>
            <hr className="mb-4"/>
            <Row>
                <Col md="12">
                    <div className="text-muted mb-2"><i>{t('ClientsGeneralEdit.bankInfoTable.title')}</i></div>
                    <EditableTable
                        tableName="Edit Employee Bank Info"
                        key={"Edit employee Bank Info" + bankInfoIncrKey}
                        allowActions={true}
                        columns={bankInfoTableColumns}
                        data={editEmployee.bankInfo}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={bankInfoTableActions}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <div className="text-muted mb-2"><i>{t('PosNew.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('PosNew.addNotes')}
                        name="notes"
                        limit="1000"
                        value={editEmployee.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export const EmployeeEditLog = () => {
    const {t} = useTranslation();
    const editEmployee = useSelector((state) => state.ACCOUNTING_DATA.editEmployee);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.employeeLog')}</i></div>
            <LogTable itemId={editEmployee._id}/>
        </React.Fragment>
    )
}

export default EditEmployee;
